// Typed inline content nodes used by canonical documents and collections.
export const text = (value) => ({
    type: 'text',
    text: value,
});
export const strong = (children) => ({
    type: 'strong',
    children: richText(children),
});
export const em = (children) => ({
    type: 'em',
    children: richText(children),
});
export const link = (href, children) => ({
    type: 'link',
    href,
    children: richText(children),
});
export const docLink = (documentId, children) => ({
    type: 'docLink',
    documentId,
    children: richText(children),
});
export const collectionLink = (collectionId, children) => ({
    type: 'collectionLink',
    collectionId,
    children: richText(children),
});
export const richText = (input) => typeof input === 'string' ? [text(input)] : input;
//# sourceMappingURL=richText.js.map